function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "tgg_b",
  x1: 0.6667,
  y1: 0.1667,
  x2: 0.4167,
  y2: 0.75
}, React.createElement("stop", {
  stopColor: "#37aee2",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#1e96c8",
  offset: 1
})), React.createElement("linearGradient", {
  id: "tgg_w",
  x1: 0.6597,
  y1: 0.4369,
  x2: 0.8512,
  y2: 0.8024
}, React.createElement("stop", {
  stopColor: "#eff7fc",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#fff",
  offset: 1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 120,
  cy: 120,
  r: 120,
  fill: "url(#tgg_b)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c8daea",
  d: "m98 175c-3.8876 0-3.227-1.4679-4.5678-5.1695L82 132.2059 170 80"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#a9c9dd",
  d: "m98 175c3 0 4.3255-1.372 6-3l16-15.558-19.958-12.035"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#tgg_w)",
  d: "m100.04 144.41 48.36 35.729c5.5185 3.0449 9.5014 1.4684 10.876-5.1235l19.685-92.763c2.0154-8.0802-3.0801-11.745-8.3594-9.3482l-115.59 44.571c-7.8901 3.1647-7.8441 7.5666-1.4382 9.528l29.663 9.2583 68.673-43.325c3.2419-1.9659 6.2173-0.90899 3.7752 1.2584"
});

var SvgLogoTelegram = function SvgLogoTelegram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-telegram.fa991c50.svg";
export { ForwardRef as ReactComponent };